/** CDN root for Performance Lab landing page v2 uploads. */
export const PL_LANDING_V2_BASE = 'web_v2/performance-lab/landing-page/v2';

export const PERFORMANCE_LAB_VISION_DEMO_URL =
  'https://vision.ultrahuman.com/demo/performance-lab';

export type ResponsiveParallaxBg = {
  mobile: string;
  desktop: string;
};

export const PINCODE_PARALLAX_BG: ResponsiveParallaxBg = {
  mobile: `${PL_LANDING_V2_BASE}/bg/pin-bg-no-overlay-new-min.png`,
  desktop: `${PL_LANDING_V2_BASE}/bg/pin-bg-no-overlay-new-full.png`,
};

export const DATA_PARALLAX_BG: ResponsiveParallaxBg = {
  mobile: `${PL_LANDING_V2_BASE}/bg/data-bg-no-overlay-min.png`,
  desktop: `${PL_LANDING_V2_BASE}/bg/data-bg-no-overlay-full.png`,
};

export const RECOVERY_HERO_BG = `${PL_LANDING_V2_BASE}/recover/recover-hero-bg-clean.png/w_2048`;

export const CONTACT_CAROUSEL_BASE = `${PL_LANDING_V2_BASE}/contact/carousel`;
